import React from "react";
import { Box, TextField, Typography } from "@mui/material";

interface MessageInputProps {
  label?: string;
  subLabel?: string;
  placeholder?: string;
  maxLength?: number;
  value: string;
  onChange: (value: string) => void;
}

const MessageInput: React.FC<MessageInputProps> = ({
  label,
  subLabel = "",
  placeholder = "Enter your message",
  maxLength = 160,
  value,
  onChange,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        width: "100%",
      }}
    >
      <Typography
        component="label"
        sx={{
          fontSize: "14px",
          fontWeight: 500,
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        {label}
        {subLabel && (
          <Typography
            component="span"
            sx={{
              color: "red",
              fontSize: "12px",
              fontWeight: 400,
            }}
          >
            {subLabel}
          </Typography>
        )}
      </Typography>

      <Box sx={{ position: "relative" }}>
        <TextField
          placeholder={placeholder}
          multiline
          rows={4}
          variant="outlined"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          inputProps={{
            maxLength,
          }}
          sx={{
            width: "100%",
            backgroundColor: "#F4F4F4",
            borderRadius: "8px",
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "transparent",
              },
              "&:hover fieldset": {
                borderColor: "transparent",
              },
              "&.Mui-focused fieldset": {
                borderColor: "transparent",
              },
            },
          }}
        />

        <Typography
          variant="body2"
          sx={{
            position: "absolute",
            bottom: 8,
            right: 8,
            color: "#888",
            fontSize: "12px",
            pointerEvents: "none",
            backgroundColor: "#F4F4F4",
            px: 0.5,
            borderRadius: "4px",
          }}
        >
          {value.length}/{maxLength}
        </Typography>
      </Box>
    </Box>
  );
};

export default MessageInput;
